import { useCallback } from 'react';
import './index.scss';
import Checkbox from '../Checkbox';
import { AIParagraphSection, ParagraphSection } from '~/interfaces/entities';

interface SnippetRowInterface {
    onCheck: (event: React.ChangeEvent<HTMLInputElement>) => void;
    checked: boolean;
    snippet: ParagraphSection | AIParagraphSection;
    index: number;
    onOpenParagraph: () => void;
}

const SnippetRow: React.FC<SnippetRowInterface> = ({
    onCheck,
    checked,
    snippet,
    index,
    onOpenParagraph,
}) => {
    const getTruncatedText = useCallback((text: string) => {
        const highlightIndex = text.indexOf('<HIGHLIGHT>');
        if (highlightIndex > 100) {
            return '...' + text.substring(highlightIndex - 50);
        }
        return text;
    }, []);

    const handleClick = (e: React.MouseEvent<HTMLElement>) => {
        // if user checks the checkbox, not open the smartviewer
        const isCheckbox = e.target.tagName === 'INPUT';

        const selection = window.getSelection();

        if ((selection && !selection.isCollapsed) || isCheckbox) {
            return;
        }

        onOpenParagraph();
    };

    return (
        <div className="cg-snippet-row">
            <div
                className={`cg-snippet-row__body ${checked ? 'cg-snippet-row__body-highlighted' : ''}`}
                onMouseUp={handleClick}
            >
                <div>
                    <Checkbox
                        value={snippet.es_section_id}
                        checked={checked}
                        onChange={onCheck}
                    />
                </div>

                {snippet.text_highlighted ? (
                    <div
                        dangerouslySetInnerHTML={{
                            __html: getTruncatedText(snippet.text_highlighted),
                        }}
                        id={`snippet-row-${index}`}
                        className="cg-snippet-row__text"
                    />
                ) : (
                    <div
                        id={`snippet-row-${index}`}
                        className="cg-snippet-row__text"
                    >
                        {snippet.text}
                    </div>
                )}

                {snippet.score && (
                    <div className="cg-snippet-row__score">
                        <span>{Number(snippet.score * 100).toFixed()}%</span>
                    </div>
                )}
            </div>
            <div className="cg-snippet-row__footer">
                {`${snippet.document.name} - Page ${snippet.page}`}
            </div>
        </div>
    );
};

export default SnippetRow;
